module.exports = "mutation setToComplete($completeInput:CompleteInput!){setToComplete(completeInput:$completeInput)}"